export const USER = 'USER'
export const CART_LIST = 'CART_LIST'
export const ORDER_ENTRY= 'ORDER_ENTRY'
export const ORDER_PRODUCT = 'ORDER_PRODUCT'
export const STORE_INFO = 'STORE_INFO'
export const KEYWORDS = 'KEYWORDS'
export const PAY_INFO = 'PAY_INFO'